const HeroSection = () => {
  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({behavior: "smooth", block: "start"});
    }
  };
  return (
    <section className="hero-section-blk">
      <video autoPlay muted loop playsInline>
        <source
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/videos/video-background.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div className="hero-section-overlay">
        <img
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/left-light-beams.png"
          alt="Left Light Beams"
          className="left-light-beam"
        />
        <img
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/right-light-beams.png"
          alt="Right Light Beam Pattern"
          className="right-light-beam "
        />
        <img
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hero-circle-pattern.png"
          alt="Hero Circle Pattern"
          className="center-light-beam"
        />
      </div>
      <div className="hero-section-content">
        <h1>AWS Partner Profile</h1>
        <p>
          iCXeed is ANZ's fastest-growing Amazon Connect & GenAI Service
          Delivery Partner (SDP), focusing exclusively on AWS-native cloud
          solutions for contact centre and customer experience transformation.
        </p>
        <div className="flex-box-blk">
          <button className="glow-button get-started-button">
            <span>Download iCXeed Battlecard</span>
            <img
              className="background-image-button"
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hover-button.png"
              alt="Hover Button"
            />
          </button>
          <button
            className="glow-button get-started-button"
            onClick={() => scrollToSection("ask-iris")}>
            <span>Ask iRis</span>
            <img
              className="background-image-button"
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hover-button.png"
              alt="Ask iRis Button"
            />
          </button>
        </div>
      </div>
      <div className="bottom-hero-pattern"></div>
    </section>
  );
};

export default HeroSection;
